import * as _ from 'underscore';

import { MapperHelper } from '../../../ts/mappers/MapperHelper';
import { IViewUsageInfo } from '../../../ts/ServerApi/types/IUsageInfo';
import { IView } from '../../../ts/ServerApi/types/IView';
import { IViewAccelerationPerf } from '../../../ts/ServerApi/types/IViewAccelerationPerf';
import { IViewAccelerationStatus } from '../../../ts/ServerApi/types/IViewAccelerationStatus';
import { IWorkbookAccelerationInfo } from '../../ServerApi/types/IWorkbookAccelerationInfo';

export module WorkbookAccelerationMapper {

  const M = MapperHelper;

  export function map(
    serverApiViews: IView[],
    usageInfoMaxValues: IViewUsageInfo,
    viewAccelerationPerfs: _.Dictionary<IViewAccelerationPerf> = {},
    viewAccelerationStatus: _.Dictionary<IViewAccelerationStatus> = {}): IWorkbookAccelerationInfo[] {

    return _.map(serverApiViews, (v: IView): IWorkbookAccelerationInfo => {
      return {
        id:                    v.id,
        luid:                  v.luid,
        index:                 M.toNumber(v.index),
        name:                  v.name,
        path:                  v.path,
        usageInfo:             v.usageInfo || <IViewUsageInfo> {},
        usageInfoMaxValues:    usageInfoMaxValues || <IViewUsageInfo> {},
        contentType:           'view',
        speedUp:               viewAccelerationPerfs[v.id] && viewAccelerationPerfs[v.id].speedUp,
        avgNonAcceleratedPLT:  viewAccelerationPerfs[v.id] && viewAccelerationPerfs[v.id].avgNonAcceleratedPLT !== 0 && viewAccelerationPerfs[v.id].avgNonAcceleratedPLT,
        avgAcceleratedPLT:     viewAccelerationPerfs[v.id] && viewAccelerationPerfs[v.id].avgAcceleratedPLT !== 0 && viewAccelerationPerfs[v.id].avgAcceleratedPLT,
        isAccelerated:         viewAccelerationStatus[v.id] && viewAccelerationStatus[v.id].isAccelerated,
        optimizationNotes:     viewAccelerationStatus[v.id] && viewAccelerationStatus[v.id].optimizationNotes,
      };
    });
  }

}
